// services/notificationService.js
import axios from "axios";
import { API } from "../shared/api/Api";

export const fetchNotifications = async (token, markAllClicked) => {
  try {
    const { data } = await axios.get(API.Notifications.allNotifications, {
      params: markAllClicked ? { allClicked: true } : {},
      headers: {
        Authorization: `Bearer ${token}`,
        lang: "en",
      },
    });
    return data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const numberUnClickedNotification = async (token) => {
  try {
    const { data } = await axios.get(
      API.Notifications.numberUnClickedNotification,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      }
    );
    return data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const markNotificationClicked = async (token, notification_id) => {
  try {
    const { data } = await axios.put(
      `${API.Notifications.notificationStatusUpdate}/${notification_id}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      }
    );

    return data;
  } catch (error) {
    console.error("Error updating notification status:", error);
    throw error;
  }
};

export const updateNotificationStatus = async (notificationId, token) => {
  try {
    const { data } = await axios.put(
      `${API.Notifications.notificationStatusUpdate}/${notificationId}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      }
    );
    return data;
  } catch (error) {
    console.error("Error updating notification status:", error);
    throw error;
  }
};

export const deleteNotification = async (notificationId, token) => {
  try {
    const { data } = await axios.delete(
      `${API.Notifications.deleteNotification}/${notificationId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      }
    );
    return data;
  } catch (error) {
    console.error("Error deleting notification:", error);
    throw error;
  }
};

export const deleteAllNotifications = async (token) => {
  try {
    const { data } = await axios.delete(
      API.Notifications.deleteAllNotification,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          lang: "en",
        },
      }
    );
    return data;
  } catch (error) {
    console.error("Error deleting all notifications:", error);
    throw error;
  }
};

export const markAllAsRead = async (token) => {
  try {
    const { data } = await axios.get(API.Notifications.allNotifications, {
      params: { allClicked: true },
      headers: {
        Authorization: `Bearer ${token}`,
        lang: "en",
      },
    });
    return data;
  } catch (error) {
    console.error("Error marking all as read:", error);
    throw error;
  }
};
